import {Expressions} from '@packages/systems/wfdl';
import type {Expression} from '@packages/systems/wfdl-ast';
import {getDynamoBindingPaths} from './getDynamoBindingPaths';

export function isDynamoImgBinding(expression?: Expression): boolean {
  if (!expression) {
    return false;
  }
  const bindings = Expressions.getRecord(expression);
  if (!bindings || !bindings.img) {
    return false;
  }
  const dynamoBindingPaths = getDynamoBindingPaths(bindings.img);
  return dynamoBindingPaths.length === 1;
}
